import { render, staticRenderFns } from "./getSMS.vue?vue&type=template&id=2dd835af&scoped=true"
import script from "./getSMS.vue?vue&type=script&lang=js"
export * from "./getSMS.vue?vue&type=script&lang=js"
import style0 from "./getSMS.vue?vue&type=style&index=0&id=2dd835af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd835af",
  null
  
)

export default component.exports